<template>
  <div class="wrapper">
    <loading
      name="lp"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <notifications></notifications>
    <parallax
      class="page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div
            class="
              md-layout-item md-size-66 md-small-size-100
              mx-auto
              text-center
            "
          ></div>
        </div>
      </div>
    </parallax>

    <div class="main main-raised">
      <div class="section pb-0">
        <div class="container t1">
          <div class="sticky-menu">
            <!-- <div class="scroll"></div> -->
            <!-- <md-button
                :key="item.id"
                v-for="item in first"
                v-scroll-to="{ el: '#A' + item.id, offset: -120 }"
                to
              >
                {{ item.name }}
              </md-button> -->
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-field>
                  <md-select
                    :placeholder="labels.cat"
                    v-model="selected"
                    name="headers"
                    id="headers"
                    @md-closed="goto()"
                  >
                    <md-option
                      :key="item.id"
                      v-for="item in first"
                      :value="item.id"
                      style="font-size: 16pt"
                    >
                      {{ item.name }}</md-option
                    >
                  </md-select>
                </md-field>
              </div>
            </div>
          </div>
          <div class="md-layout">
            <div
              style="padding-left: 20px; width: 100%"
              v-for="f in first"
              :key="f.id"
            >
              <div :ref="'A' + f.id">
                <h2 class="section-title">{{ f.name }}</h2>
                <div style="width: 100%" v-for="s in second(f.id)" :key="s.id">
                  <h3 class="section-title" v-if="second(f.id).length > 1">{{ s.name }}</h3>
                  <div
                    style="width: 100%"
                    :key="dish.id"
                    v-for="dish in dishlistbycat(s.id)"
                  >
                    <product-card-small
                      text-center
                      class="mt-0 mb-0"
                      card-plain
                      :imageExists="dish.picture !== null"
                      :card-image="
                        dish.picture === null ? nophoto : fileurl + dish.picture
                      "
                      :shadow-off="true"
                      :id="dish.id"
                      @clicked="showImages"
                      :popular="dish.selected === '1'"
                      :visible="dish.visible === '1'"
                      :discount="dish.discount === '1'"
                    >
                      <template slot="cardContent">
                        <h4
                          class="title mt-0 mb-0 pt-0 pb-0"
                          style="
                            text-align: left;
                            margin: 0px;
                            padding: 0px;
                            min-height: 0px;
                            padding-right: 10px;
                          "
                        >
                          {{ dish.title }}
                        </h4>
                        <p
                          style="
                            font-size: 14px;
                            text-align: left;
                            margin: 0px;
                            padding: 0px;
                            min-height: 0px;
                            padding-right: 10px;
                          "
                          class="text-muted m-0 p-0"
                        >
                          {{ dish.description }}
                        </p>
                      </template>
                      <template slot="cardAction">
                        <div class="md-layout">
                          <div class="md-layout-item md-size-100">
                            <div
                              style="text-align: right"
                              :key="price.name"
                              v-for="price in dish.price"
                            >
                              <div class="price-container-2" width="100%">
                                <table
                                  cellspacing="0"
                                  cellpadding="0"
                                  width="100%"
                                  style="padding-right: 10px"
                                >
                                  <tr>
                                    <td style="text-align: right">
                                      <span
                                        style="
                                          font-size: 14px;
                                          padding-left: 5px;
                                        "
                                        >{{ price.name }}</span
                                      >
                                      <!-- <br v-if="price.name" /> -->
                                      <span
                                        style="
                                          font-size: 14px;
                                          padding-left: 5px;
                                        "
                                        v-if="price.priceold > price.price"
                                        class="price price-old m-0 p-0"
                                        >₺ {{ price.priceold }}</span
                                      >
                                      <span
                                        class="price price-new m-0"
                                        style="
                                          font-size: 14px;
                                          padding-top: 10px;
                                          padding-left: 5px;
                                        "
                                        >₺ {{ price.price }}</span
                                      >
                                    </td>
                                    <!-- <td width="100px">
                                    <div class="md-group">
                                      <md-button
                                        v-if="
                                          $store.getters.itemCountInOrder(
                                            price.id
                                          ) > 0
                                        "
                                        :class="
                                          'md-just-icon md-simple md-danger'
                                        "
                                        @click="onRemoveFromBasket(price)"
                                      >
                                        <i :class="'fas fa-minus-square'" />
                                      </md-button>
                                      <span
                                        style="font-size: 12px; font-weight: bold; padding-top:10px"
                                        v-if="
                                          $store.getters.itemCountInOrder(
                                            price.id
                                          ) > 0
                                        "
                                        >{{
                                          $store.getters.itemCountInOrder(
                                            price.id
                                          )
                                        }}</span
                                      >
                                      <md-button
                                        v-if="
                                          $store.getters.itemCountInOrder(
                                            price.id
                                          ) <= 30
                                        "
                                        :class="
                                          'md-just-icon md-simple md-success'
                                        "
                                        @click="onAddToBasket(dish, price)"
                                      >
                                        <i :class="'fas fa-plus-square'" />
                                      </md-button>
                                    </div>
                                  </td> -->
                                  </tr>
                                  <tr></tr>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </product-card-small>
                    <br />
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="md-layout" v-if="dishes.length > 0">
              <div class="md-layout-item md-size-25 md-small-size-100">
                <span style="font-size: 12px">{{ "P: 193" + visits }}</span>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="sticky-ordernow" v-if="$store.getters.orderTotal > 0">
        <md-button class="md-primary md-round" @click="onOrder">
          <md-icon>shopping_basket</md-icon> {{ labels.ordernow }}: ₼
          {{ $store.getters.orderTotal }}
        </md-button>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" :fullscreen="true" :center="true">
      <el-carousel trigger="hover" :interval="5000">
        <el-carousel-item v-for="item in carousel" :key="item.name">
          <el-image
            style="width: 100%; height: 100%"
            :src="fileurl + item.name"
            fit="contain"
          ></el-image>
        </el-carousel-item>
      </el-carousel>
      <div style="text-align: center">
        <md-button class="md-default" @click="dialogVisible = false">
          {{ labels.close }}
        </md-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="langVisible"
      :fullscreen="true"
      :center="true"
      :show-close="false"
    >
      <div class="md-layout md-alignment-center-center">
        <div class="md-layout-item md-small-size-100 md-size-33">
          <h4 style="text-align: center">
            Dil seçin / Select language / Выберите язык
          </h4>
          <md-button
            style="width: 100%"
            class="md-raised"
            to
            @click="onLang('AZ')"
            ><img style="margin-left: -35px" :src="azflag" /><span
              style="padding-left: 10px"
              >Türkçe</span
            ></md-button
          >
          <br />
          <md-button style="width: 100%" to @click.native="onLang('EN')"
            ><img style="margin-left: -30px" :src="enflag" /><span
              style="padding-left: 10px"
            >
              English</span
            ></md-button
          >
          <br />
          <md-button style="width: 100%" to @click.native="onLang('RU')"
            ><img style="margin-left: -25px" :src="ruflag" /><span
              style="padding-left: 10px"
              >Русский</span
            ></md-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ProductCardSmall, Slider, Modal } from "@/components";
import { mapState } from "vuex";
import Mixins from "@/plugins/basicMixins";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {
  fileUrl,
  nophoto,
  Round2,
  AZ_Flag,
  RU_Flag,
  EN_Flag,
} from "../services/helper";
import { VisitCount } from "../services/share";
import {
  Popover,
  Button,
  Carousel,
  CarouselItem,
  Dialog,
  Card,
  Image,
  Backtop,
  Select,
  Option,
} from "element-ui";
export default {
  components: {
    ProductCardSmall,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Popover.name]: Popover,
    [Button.name]: Button,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem,
    [Dialog.name]: Dialog,
    [Card.name]: Card,
    [Image.name]: Image,
    [Backtop.name]: Backtop,
  },
  props: {
    id: String,
    cid: String,
    subid: String,
  },
  mixins: [Mixins.HeaderImage],
  data() {
    return {
      selected: "",
      nophoto: nophoto,
      isActive: 1,
      colorCollapse: "primary",
      isLoading: false,
      catpath: "",
      carousel: [],
      dialogVisible: false,
      langVisible: false,
      labels: {
        close: this.localeLabel("close"),
        showIngradient: this.localeLabel("ingrad"),
        findTitle: this.localeLabel("filter"),
        showall: this.localeLabel("showall"),
        search: this.localeLabel("search"),
        found: this.localeLabel("found"),
        result: this.localeLabel("searchresult"),
        or: this.localeLabel("or"),
        selectcat: this.localeLabel("selectcat"),
        tobasket: this.localeLabel("tobasket"),
        price: this.localeLabel("price"),
        total: this.localeLabel("total"),
        count: this.localeLabel("count"),
        continueshop: this.localeLabel("continueshop"),
        gotobasket: this.localeLabel("gotobasket"),
        available: this.localeLabel("available"),
        ordernow: this.localeLabel("ordernow"),
        cat: this.localeLabel("cat"),
      },
      search: "",
      visits: "",
      rnd: 0,
      tobasketModal: false,
      newItem: {
        id: "",
        title: "",
        picture: "",
        priceid: "",
        spec: "",
        price: 0,
        count: 1,
        discount: 0,
        amount: 0,
      },
      newItemPrices: [],
      addedToBasket: false,
      azflag: AZ_Flag,
      enflag: EN_Flag,
      ruflag: RU_Flag,
    };
  },

  methods: {
    goto(clicked) {
      var element = this.$refs["A" + this.selected];
      if (!element) return;
      var top = element[0].offsetTop;
      window.scrollTo(0, top + window.innerHeight / 2 - 40);
    },
    onLang(lg) {
      this.$store.dispatch("setLang", lg);
      // this.$router.go(0);
      window.location.reload()
    },

    showImages(id) {
      this.carousel = [];
      this.carousel = this.dishes.filter((d) => d.id === id)[0].images;
      if (this.carousel) this.dialogVisible = true;
    },
    onSearchClick() {
      if (this.search === "") {
        this.$refs.colcats.isActive = 1;
        this.refreshPath();
      } else this.rnd = Math.floor(Math.random() * 100);
    },

    clearItem() {
      this.newItem.id = "";
      this.newItem.title = "";
      this.newItem.picture = "";
      this.newItem.spec = "";
      this.newItem.priceid = "";
      this.newItem.price = 0;
      this.newItem.count = 1;
      this.newItem.amount = 0;
      this.newItemPrices = [];
      this.addedToBasket = false;
    },
    showToBasket(item) {
      let price = Object.assign({}, item);
      this.clearItem();
      this.newItem.id = price.id;
      this.newItem.title = price.title;
      this.newItem.picture = price.picture;
      this.newItem.priceid = price.price[0].id;
      this.newItem.spec = price.price[0].name;
      this.newItem.price = Round2(price.price[0].price);
      this.newItem.amount = Round2(price.price[0].price);
      this.newItem.availablefrom = price.availablefrom;
      this.newItem.availableto = price.availableto;
      this.newItemPrices = price.price;
      this.addedToBasket = false;
      this.tobasketModal = true;
    },

    onAddToBasket(item, price) {
      this.clearItem();
      this.newItem.id = item.id;
      this.newItem.title = item.title;
      this.newItem.priceid = price.id;
      this.newItem.spec = price.name;
      this.newItem.price = Round2(price.price);
      this.newItem.amount = Round2(price.price);

      this.$store.dispatch("addToOrder", Object.assign({}, this.newItem));
    },
    itemCountInBasket(id) {
      return this.$store.getters.itemCountInOrder(id);
    },
    onRemoveFromBasket(price) {
      let item = {};
      item.priceid = price.id;
      item.count = this.itemCountInBasket(price.id) - 1;
      console.log(item.count);
      if (item.count < 0) return;
      item.amount = Round2(item.count * price.price);
      this.$store.dispatch("updateItemCount", item);
    },
    onOrder() {
      this.tobasketModal = false;
      this.$router.push({ path: "/cart2/" + this.id });
    },
    second(id) {
      var list = this.cats.filter((c) => c.parentid === id);
      return list ? list : [];
    },
    dishlistbycat(id) {
      return this.dishes.filter(
        (c) =>
          (c.categoryid === id && this.search === "") ||
          (this.search !== "" &&
            c.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
      );
    },

    handleScroll(event) {
      let scrollTop = window.scrollY;
      let currRef = "";
      let top = window.innerHeight / 2 - 40;
      for (var ref in this.$refs) {
        let currTop = this.$refs[ref][0].offsetTop + top;
        let currHeight = this.$refs[ref][0].offsetHeight;
        if (scrollTop >= currTop && scrollTop < currTop + currHeight) {
          currRef = ref;
          break;
        }
      }
      this.selected = currRef.substring(1);
    },
  },
  created() {
    this.$store.dispatch("fetchMenuBkg", this.id);
    this.$store.dispatch("fetchDishes", this.id);
    this.$store.dispatch("fetchCategories", this.id);
    this.$store.dispatch("fetchInfo", this.id);
    this.langVisible = !this.$store.state.lang;
    VisitCount(this.id).then((response) => {
      if (response.data.result) {
        this.visits = response.data.result;
      }
    });
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    ...mapState({
      cats: (state) => state.cats,
      dishes: (state) => state.dishes,
      bkg: (state) => state.menubkg,
    }),
    fileurl() {
      return fileUrl;
    },
    image() {
      return this.bkg ? this.fileurl + this.bkg : "";
    },
    first() {
      let list = this.cats.filter((c) => c.parentid === "");
      return list;
    },
    dscount() {
      return this.ds.length;
    },
  },
};
</script>

<style lang="scss" >
.mt-3 {
  margin-top: 1.875rem * 2;
}
.mb-0 {
  margin-bottom: 0;
}
.is-active {
  font-weight: 800;
}
.text-left {
  text-align: left;
}
@media only screen and (max-width: 600px) {
  .text-left {
    text-align: center;
  }
}
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}
.vertical-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.padding-top-20 {
  padding-top: 20px;
}

.sticky-ordernow {
  position: fixed;
  right: 30px;
  bottom: 0;
}

.sticky-menu {
  position: -webkit-sticky; // required for Safari
  position: sticky;
  top: 70px; // required as well.
  z-index: 1000000;
  background: white;
}

.scroll {
  margin: 4px, 4px;
  padding: 4px;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}

.md-menu-content.md-select-menu {
  width: auto;
  max-width: none;
  height: 500px;
  max-height: none;
}
</style>
